import { EnumInterface } from '@/domain/interface/intern/enumvalues/EnumInterface';
import { EindbeoordelingCommonFieldsClass } from '@/domain/interface/activiteit/eindbeoordeling/EindbeoordelingCommonFieldsClass';

export default class EindbeoordelingKeuringStooktoestelClass extends EindbeoordelingCommonFieldsClass {
  id: string;
  stooktoestelConform?: EnumInterface;
  rookgasafvoerkanaalConform?: EnumInterface;
  stookplaatsConform?: EnumInterface;
  verbrandingscontrole?: EnumInterface;
  toestelWerkingGoed?: EnumInterface;
  toestelWerkingVeilig?: EnumInterface;

  constructor(eindbeoordeling?: EindbeoordelingKeuringStooktoestelClass) {
    super(eindbeoordeling);
    this.id = eindbeoordeling?.id || '';
    this.stooktoestelConform = eindbeoordeling?.stooktoestelConform;
    this.rookgasafvoerkanaalConform =
      eindbeoordeling?.rookgasafvoerkanaalConform;
    this.stookplaatsConform = eindbeoordeling?.stookplaatsConform;
    this.verbrandingscontrole = eindbeoordeling?.verbrandingscontrole;
    this.toestelWerkingGoed = eindbeoordeling?.toestelWerkingGoed;
    this.toestelWerkingVeilig = eindbeoordeling?.toestelWerkingVeilig;
  }
}
